import {
  initChart,
  resultsetWithFields,
  printNoDataChart,
  printDataChart,
  formatDayMonthYear,
  subtractOneDay,
  formatShortMonthYear,
  subtractOneMonth,
} from 'vlcishared';
import { OPTIONS_INTERVENCIONES_BAR as options } from './options-charts';
import { TEXTS_SEGURIDAD } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';

export function echartIntervencionesTotalesBar(vis, datos, idChart, idNoData) {
  let chartOptions = JSON.parse(JSON.stringify(options));
  chartOptions.tooltip.formatter = options.tooltip.formatter; // Importante porque los formatter con funciones dinámicas no se clonan con JSON.parse
  chartOptions.xAxis.axisLabel.formatter = options.xAxis.axisLabel.formatter;

  const resultSet = resultsetWithFields(datos);
  if (resultSet.length === 0) {
    printNoDataChart(`#${idChart}`, `#${idNoData}`);
  } else {
    printDataChart(`#${idNoData}`, `#${idChart}`);
  }

  resultSet.forEach((row) => {
    chartOptions.xAxis.data.push(row.district);
    chartOptions.series[0].data.push(row.count);
  });

  if (idChart == 'chart_IntervencionesMesSeguridadCiudadana') {
    const paramUltimoDia = Dashboards.getParameterValue('paramUltimoDia');
    const ultimoDia = subtractOneDay(paramUltimoDia);
    chartOptions.title.subtext =
      TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('barrio') +
      ' 1' +
      '-' +
      formatDayMonthYear(ultimoDia);
    chartOptions.media = [
      {
        //barWidth peq
        query: {
          maxWidth: 639,
        },
        option: {
          series: {
            barWidth: 10,
          },
        },
      },
      {
        //barWidth big
        query: {
          minWidth: 640,
        },
        option: {
          series: {
            barWidth: 16,
          },
        },
      },
      {
        // titles maxHeight: 240
        query: {
          maxHeight: 245,
        },
        option: {
          title: {
            itemGap: 3,
            textStyle: {
              fontSize: 13,
            },
            subtextStyle: {
              fontSize: 10,
            },
          },
        },
      },
    ];
  } else if (idChart == 'chart_IntervencionesAnualSeguridadCiudadana') {
    const paramUltimoMes = Dashboards.getParameterValue('paramUltimoMes');
    const ultimoMes = subtractOneMonth(paramUltimoMes);
    chartOptions.title.subtext =
      TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('barrio') +
      ' Ene - ' +
      formatShortMonthYear(ultimoMes);
    chartOptions.media = [
      {
        //barWidth peq
        query: {
          maxWidth: 639,
        },
        option: {
          series: {
            barWidth: 10,
          },
        },
      },
      {
        //barWidth big
        query: {
          minWidth: 640,
        },
        option: {
          series: {
            barWidth: 16,
          },
        },
      },
      {
        // titles maxHeight: 240
        query: {
          maxHeight: 245,
        },
        option: {
          title: {
            itemGap: 3,
            textStyle: {
              fontSize: 13,
            },
            subtextStyle: {
              fontSize: 10,
            },
          },
        },
      },
    ];
  }

  initChart(idChart, chartOptions);
}
